/**
 * created by li si yi
 * 处理待办适配
 * 审核流待办适配器
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import BaseComponent from "../../../../base/BaseComponent";

class ProcessToDo extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {};
        this.processToDoHandlerName = [
            'busTopicSelection', // 选题
            'busNewsClue', // 线索
            'webNews', // 网站稿件
            'mediaAudit', // 媒体备案申请
            'positionAudit', // 阵地备案申请
            'zyxzsq', // 资源下载申请
            'weibo', // 微博
            'material', // 微信
            'webStoryEditor', // 稿件与网站稿件待办处理
            'tggjStoryEditor', // 投稿稿件待办处理
            'photosEditor', // 图集
            'receiveEditor', // 微信稿件待办处理
            'materiallCenterWebEditor', // 稿件与网站稿件待办处理
            'likeWebsite', // 素材中心收稿稿件
            'yuegaowr', // 约稿任务
            'caifangwr', // 采访任务
        ];
        this.processToDoHandler = [];
        (() => {
            this.processToDoHandlerName.forEach(name => {
                let component;
                try {
                    component = require(`./children/${name}`).default;
                } catch (e) {
                    console.log(e.toString())
                }
                if (name && component) {
                    this.processToDoHandler.push({
                        component: component,
                        name: name
                    })
                }
            });
        })();
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    // 点击处理
    getTodoList = (item) => {
        // console.log('item------------------', item.activitiCategoryKey);
        for (let name in this.componentList) {
            // console.log('name------------------', name);
            let isSupport = this.componentList[name]["isSupport"];
            if (isSupport && typeof isSupport === 'function' && this.componentList[name]["isSupport"](item, (status) => {
                if (status) {
                    let handle = this.componentList[name]["handle"];
                    if (handle && typeof handle === 'function') {
                        handle(item, () => this.refresh())
                    }
                }
            })) {
                let handle = this.componentList[name]["handle"];
                if (handle && typeof handle === 'function') {
                    handle(item, () => this.refresh())
                }
            }
        }
    };

    // icon
    getTodoListIcon = (item) => {
        for (let name in this.componentList) {
            let isSupport = this.componentList[name]["isSupport"];
            if (isSupport && typeof isSupport === 'function' && this.componentList[name]["isSupport"](item, (status) => {
                // if (status) {
                //     let handle = this.componentList[name]["getIcon"];
                //     if (handle && typeof handle === 'function') {
                //         handle(item, () => this.refresh())
                //     }
                // }
            })) {
                let handle = this.componentList[name]["getIcon"];
                if (handle && typeof handle === 'function') {
                    return handle(item, () => this.refresh())
                }
            }
        }
    };
    // 刷新方法
    refresh() {
        this.props.refresh && this.props.refresh()
    }

    componentList = {};

    render() {
        return (
            <div style={{display: 'none'}}>
                {
                    this.processToDoHandler && this.processToDoHandler.map((Component, index) => (
                        <Component.component ref={ref => this.componentList[Component.name] = ref} key={index}/>
                    ))
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(ProcessToDo)